import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} users
 * @returns {Workbook}
 */
export const exportExcel = async (users, selectedStore) => {
  users.forEach((user, index) => (user.order = index + 1));

  const json = excelHelper.jsonToJson(
    [users],
    [
      {
        name: "USUARIOS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "dni",
            outValue: "DNI",
          },
          {
            inValue: "email",
            outValue: "CORREO ELECTRONICO",
          },
          {
            inValue: "phone",
            outValue: "NUMERO TELEFONICO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-usuarios.xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-usuarios_" +
        storeName.toLowerCase() +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserList/excel.js